import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabservicenearmemumbai() {



  const cardData =
  {
    keyword: 'Cab Service Near Me Mumbai ',
    heading: 'Shambhu Cabs: Cab Service Near Me Mumbai',
    headingDescription: 'Shambhu Cabs offers reliable Cab Service Near Me in Mumbai, providing safe, comfortable, and hassle-free travel for daily commuters, families, tourists, and corporate travelers across the city. Our fleet of well-maintained hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and convenient travel experience for local rides, airport transfers, outstation trips, and full-day rentals. With doorstep pickup available in South Mumbai, Western Suburbs, Central Mumbai, Navi Mumbai, and Thane, Shambhu Cabs makes every journey seamless and stress-free. We offer transparent fares, experienced chauffeurs, flexible booking options, and 24/7 customer support to ensure complete satisfaction. Whether you need a short city ride or a long-distance journey, Shambhu Cabs provides trusted “cab service near me” in Mumbai for comfort, safety, and reliability.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s iconic stone arch built to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, it stands as a historic entry point for British governors and a symbol of colonial-era architecture. Today, visitors enjoy ferry rides to Elephanta Island, street food stalls, coastal photography, and a lively promenade filled with tourists, performers, and vendors. Its illuminated evenings create a stunning waterfront ambiance that reflects the essence of Mumbai."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive is Mumbai’s famous 3.6 km-long coastline, known for its curved boulevard that glitters like a ‘Queen’s Necklace’ at night. The promenade is ideal for morning jogs, romantic walks, cycling, and enjoying refreshing sea breezes. The Art Deco buildings lining the stretch add heritage value, making it one of the world’s largest collections of Art Deco architecture. Sunsets here are especially mesmerizing, drawing locals, tourists, and photographers to soak in the city’s vibrant coastal charm."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, a UNESCO World Heritage Site, is an architectural masterpiece blending Victorian Gothic Revival and Indian traditional designs. Built in 1887, it is one of India’s busiest railway stations and a symbol of Mumbai’s historic importance. Its grand domes, stained glass windows, carvings of flora and fauna, and intricate pillars make it a living museum. The nighttime lighting further enhances its majesty, making it a must-visit landmark for history, architecture, and photography enthusiasts."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, famous for its vibrant street food culture, local entertainers, and stunning sunsets. Visitors indulge in Mumbai’s iconic snacks like pav bhaji, bhel puri, and gola while enjoying camel rides, kite flying, and beach sports. The beach is also frequently visited by Bollywood celebrities who live in the surrounding areas. Its lively yet relaxed atmosphere makes it a perfect escape for families, couples, and tourists."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shree Siddhivinayak Temple in Prabhadevi is one of India’s most revered Ganesha temples, believed to fulfill devotees’ wishes. The temple’s wooden doors depict Ashtavinayak carvings, and the gold-plated sanctum adds to its spiritual aura. Thousands queue up daily for darshan, including celebrities and leaders. During Ganesh Chaturthi, the entire area comes alive with devotional music, lights, and vibrant processions, showcasing Mumbai’s deep spiritual culture."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, situated on an islet connected by a narrow causeway, is a stunning Indo-Islamic structure honoring Sufi saint Pir Haji Ali Shah Bukhari. Surrounded by the sea on all sides, it offers breathtaking views and a serene spiritual experience. The white marble structure, religious hymns, and peaceful setting attract visitors of all faiths. The walk to the dargah during low tide is a unique experience, blending spirituality with natural beauty."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, a UNESCO World Heritage Site located on Elephanta Island, feature ancient rock-cut sculptures dedicated primarily to Lord Shiva. The 5th–8th century caves include magnificent carvings like the massive Trimurti (three-faced Shiva), Nataraja, and various mythological scenes. Visitors reach the island via ferry from the Gateway of India, experiencing a combination of history, art, nature, and coastal adventure."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel that connects Mumbai’s western suburbs to South Mumbai. Its cable-stayed architecture, sweeping curves, and views of the Arabian Sea make it a visual delight. The bridge significantly reduces travel time, symbolizing Mumbai’s modern urban growth. The best time to view the Sea Link is during sunrise, sunset, or night when the bridge lights create a spectacular skyline view."
  },
  {
    "title": "Chor Bazaar",
    "description": "One of India’s oldest and most famous flea markets, Chor Bazaar is known for its antique furniture, vintage Bollywood posters, cameras, gramophones, lamps, and rare collectibles. Walking through its busy lanes offers a glimpse into Mumbai’s historic trade culture. Bargain hunters, interior designers, and collectors frequent the area to discover unique treasures. It remains a buzzing hotspot for culture, photography, and old-world charm."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread over 100 sq km, Sanjay Gandhi National Park is Mumbai’s green lung and a biodiversity hotspot. Visitors enjoy nature trails, lion and tiger safaris, boating, cycling routes, and the ancient Kanheri Caves inside the park. Home to leopards, deer, monkeys, and hundreds of bird species, it offers a jungle retreat in the middle of the city. The park is perfect for trekking, wildlife photography, and peaceful nature escapes."
  },
  {
    "title": "Mount Mary Church",
    "description": "The Basilica of Our Lady of the Mount, popularly called Mount Mary Church, is located atop a hill in Bandra offering beautiful views of the sea. The church is known for its stunning Gothic architecture, peaceful interiors, and the annual Bandra Fair held in September. Devotees across religions visit to seek blessings, light candles, and enjoy the serene surroundings. It is one of Mumbai’s most significant spiritual and cultural landmarks."
  }
],




"services": [
  {
    "name": "Cab Near Me Now Mumbai",
    "description": "Cab Near Me Now Mumbai offers instant taxi services to passengers looking for quick and convenient travel within the city. With GPS-enabled vehicles and professional drivers, customers can locate nearby cabs, enjoy prompt pickups, and travel safely and comfortably. Ideal for local rides, airport transfers, or urgent trips, the service ensures 24×7 availability and easy online booking."
  },
  {
    "name": "Taxi Near Me Mumbai",
    "description": "Taxi Near Me Mumbai provides reliable and affordable taxi options located close to your location. The service includes sedans, SUVs, and AC cabs for local, outstation, or airport travel. With real-time tracking, professional chauffeurs, and fast response times, passengers can enjoy hassle-free rides anytime in Mumbai."
  },
  {
    "name": "Local Cab Near Me Mumbai",
    "description": "Local Cab Near Me Mumbai focuses on point-to-point transportation within the city. With well-maintained vehicles, experienced drivers, and 24×7 availability, passengers can travel safely and comfortably to their destinations. Perfect for office commutes, shopping trips, and family outings, the service is affordable and easy to book online."
  },
  {
    "name": "Best Cab Near Me Mumbai",
    "description": "Best Cab Near Me Mumbai offers premium and reliable cab services for travelers looking for top-quality rides. With a fleet of sedans, SUVs, and AC cabs, professional drivers, and round-the-clock service, customers can experience punctual, safe, and comfortable journeys anywhere in Mumbai. Online booking and transparent pricing enhance convenience and reliability."
  },
  {
    "name": "Affordable Cab Near Me",
    "description": "Affordable Cab Near Me provides cost-effective and budget-friendly taxi options for local, airport, and outstation travel. Passengers can choose from sedans, SUVs, or AC cabs with professional drivers and enjoy timely pickups, comfortable rides, and transparent fare estimates. The service is ideal for families, daily commuters, and occasional travelers seeking safe yet economical transport."
  },
  {
    "name": "24×7 Cab Near Me Mumbai",
    "description": "24×7 Cab Near Me Mumbai ensures round-the-clock availability for all travel needs within and outside the city. Whether it's an urgent ride, airport transfer, or late-night travel, passengers can rely on professional drivers, clean vehicles, and quick pickups. With online booking and real-time tracking, the service provides safe, convenient, and timely rides."
  },
  {
    "name": "Fast Cab Near Me",
    "description": "Fast Cab Near Me focuses on quick response and efficient travel, ensuring passengers reach their destinations promptly. Ideal for urgent trips, office commutes, and airport transfers, the service offers sedans, SUVs, and AC cabs with professional chauffeurs. Customers can easily book online or via mobile for a speedy and hassle-free ride experience."
  },
  {
    "name": "AC Taxi Near Me Mumbai",
    "description": "AC Taxi Near Me Mumbai provides comfortable and cool rides in fully air-conditioned vehicles. Suitable for local city travel, airport transfers, and outstation trips, passengers enjoy a relaxed and smooth journey with professional drivers, online booking, and 24×7 availability."
  },
  {
    "name": "Airport Cab Near Me",
    "description": "Airport Cab Near Me ensures timely and convenient transfers to and from Mumbai airports. With sedans, SUVs, and premium cars available, professional chauffeurs, and real-time tracking, passengers can enjoy a stress-free airport journey. The service is available for both departures and arrivals, with online booking for added convenience."
  },
  {
    "name": "Outstation Cab Near Me Mumbai",
    "description": "Outstation Cab Near Me Mumbai offers reliable long-distance travel from your location to nearby cities and towns. With well-maintained sedans, SUVs, and premium vehicles, experienced drivers, and transparent fare estimates, passengers enjoy safe, comfortable, and punctual journeys for family trips, business travel, or leisure tours."
  },
  {
    "name": "Sedan Cab Near Me",
    "description": "Sedan Cab Near Me provides comfortable rides in well-maintained sedans, ideal for small families, solo travelers, or corporate passengers. With experienced drivers, timely pickups, and online booking, the service ensures a smooth and safe ride within Mumbai or for outstation trips."
  },
  {
    "name": "SUV Cab Near Me",
    "description": "SUV Cab Near Me offers spacious and comfortable travel options for families, groups, or travelers with extra luggage. With professional drivers, 24×7 availability, and online booking, passengers enjoy safe, convenient, and premium rides for local or long-distance journeys in Mumbai."
  },
  {
    "name": "Nearby Taxi Service Mumbai",
    "description": "Nearby Taxi Service Mumbai helps passengers quickly locate cabs near their current location. With a variety of vehicle options, professional drivers, and real-time tracking, the service ensures fast, safe, and comfortable travel for city rides, airport transfers, and outstation trips."
  },
  {
    "name": "Nearest Cab Booking Mumbai",
    "description": "Nearest Cab Booking Mumbai allows users to instantly book the closest available cabs via online or mobile platforms. With prompt pickups, well-maintained vehicles, and professional drivers, passengers can enjoy safe, affordable, and convenient rides anywhere in Mumbai."
  },
  {
    "name": "Local Ride Near Me Mumbai",
    "description": "Local Ride Near Me Mumbai provides easy and reliable point-to-point transportation within the city. Perfect for office commutes, errands, and family outings, the service offers sedans, SUVs, and AC cabs with experienced drivers and 24×7 availability for comfortable and timely travel."
  },
  {
    "name": "Online Cab Near Me",
    "description": "Online Cab Near Me offers digital booking for nearby taxis, enabling instant confirmation and secure payment. Passengers can select from sedans, SUVs, and premium vehicles, ensuring a hassle-free, safe, and convenient ride experience within Mumbai or for outstation travel."
  },
  {
    "name": "Pickup Drop Cab Near Me",
    "description": "Pickup Drop Cab Near Me provides seamless point-to-point transportation for homes, offices, or airports. With professional drivers, well-maintained vehicles, and 24×7 availability, passengers can enjoy convenient, safe, and comfortable travel with easy online booking and transparent pricing."
  }
],

"tableData": [
  ["Cab Near Me Now Mumbai", "Taxi Near Me Mumbai"],
  ["Local Cab Near Me Mumbai", "Best Cab Near Me Mumbai"],
  ["Affordable Cab Near Me", "24×7 Cab Near Me Mumbai"],
  ["Fast Cab Near Me", "AC Taxi Near Me Mumbai"],
  ["Airport Cab Near Me", "Outstation Cab Near Me Mumbai"],
  ["Sedan Cab Near Me", "SUV Cab Near Me"],
  ["Nearby Taxi Service Mumbai", "Nearest Cab Booking Mumbai"],
  ["Local Ride Near Me Mumbai", "Online Cab Near Me"],
  ["Pickup Drop Cab Near Me", "—"]
],



"whychoose": [
  {
    "WhyChooseheading": "Cab Service Near Me in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers convenient cab services near you in Mumbai, ideal for city travel, airport transfers, and quick point-to-point rides."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs for a safe and comfortable ride across Mumbai."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai Roads",
    "WhyChoosedescription": "Our professional drivers know all major routes and shortcuts in Mumbai, ensuring timely, smooth, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear, upfront pricing—fuel, tolls, and driver allowances included—making your cab service in Mumbai stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel queries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for City Travel",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans designed to meet your travel needs in Mumbai."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before each trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and smooth service, making your travel in Mumbai comfortable, quick, and worry-free."
  }
]
























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab services near me in Mumbai?',
    answer: 'Yes, Shambhu Cabs offers convenient and reliable cab services across Mumbai, ensuring a nearby and timely ride whenever you need it.',
  },
  {
    question: 'How can I book a cab near me in Mumbai with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team to locate the nearest available cab.',
  },
  {
    question: 'What types of vehicles are available for cab service near me in Mumbai?',
    answer: 'Shambhu Cabs offers sedans, SUVs, and premium cars suitable for individual, family, and group travel within Mumbai.',
  },
  {
    question: 'Are drivers experienced for cab services near me in Mumbai?',
    answer: 'Yes, our drivers are licensed, professional, and well-acquainted with Mumbai city routes to ensure a safe and timely journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for cab services near me in Mumbai?',
    answer: 'Absolutely. You can select any pickup and drop-off points anywhere in Mumbai according to your convenience.',
  },
  {
    question: 'Is cab service near me available 24x7 in Mumbai?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock cab services in Mumbai, so a cab is always nearby when you need it.',
  },
  {
    question: 'Are safety and hygiene protocols followed for cab services near me in Mumbai?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene measures for passenger well-being.',
  },
  {
    question: 'What payment options are available for cab services near me in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during cab service near me in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your cab journey in Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Joshi',
    feedback: 'Shambhu Cabs is always nearby and reliable. The service is prompt, comfortable, and professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ananya Singh',
    feedback: 'Highly satisfied with Shambhu Cabs. Great cab service near me in Mumbai with clean cars and punctual drivers.',
    rating: 5,
  },
];

























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service Near Me Mumbai",
  "image": "https://www.shambhucab.com/assets/images/cab-service-near-me-mumbai.jpg",
  "description": "Shambhu Cabs offers convenient cab services near you in Mumbai. Choose from local rides, airport transfers, outstation trips, and corporate travel in sedans, SUVs, and AC cabs. Available 24×7 with safe, fast, and affordable online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/cab-service-near-me-mumbai"
  }
};





  return (
    <div>
<Helmet>
  <title>Cab Service Near Me Mumbai | Local, Airport & Outstation | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book cab services near you in Mumbai with Shambhu Cabs. Sedans, SUVs, and AC cabs for local rides, airport transfers, outstation trips, and corporate travel. Safe, fast, reliable, and available 24×7 with online booking."
  />

  <meta
    name="keywords"
    content="Cab Near Me Now Mumbai, Taxi Near Me Mumbai, Local Cab Near Me Mumbai, Best Cab Near Me Mumbai, Affordable Cab Near Me, 24×7 Cab Near Me Mumbai, Fast Cab Near Me, AC Taxi Near Me Mumbai, Airport Cab Near Me, Outstation Cab Near Me Mumbai, Sedan Cab Near Me, SUV Cab Near Me, Nearby Taxi Service Mumbai, Nearest Cab Booking Mumbai, Local Ride Near Me Mumbai, Online Cab Near Me, Pickup Drop Cab Near Me"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/39.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabservicenearmemumbai;